import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	ofTotalCount: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	ofTotalCount: {
		id: 'jql-builder-basic-picker.async-select.pagination-details.of-total-count',
		defaultMessage: '{itemsCount} of {totalCount}',
		description: 'Total count of items.',
	},
});
export default messages;
